import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import ScrollButton from "../../../ScrollButton/ScrollButton"
import { scrollToTop } from "../../../../utils/scrollToTop"

export const Copyright = () => (
  <CopyRight>
    <p>
      © 2023 ECR Retails Loss. All Rights Reserved
      <span>|</span>
      <Link href="/privacy">Privacy Policy</Link>
    </p>
    <ScrollButton
      onClick={scrollToTop}
      label={"Back to top"}
      textColor="#11364E"
    />
  </CopyRight>
)

const CopyRight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0 17px;
  margin-top: 35px;
  border-top: 1px solid ${({ theme }) => theme.colors.primary_color};

  @media (max-width: ${({ theme }) => theme.media.mobile_max}) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    padding: 29px 0;
  }

  p,
  a,
  span {
    font-size: 10px;
    color: ${({ theme }) => theme.colors.fourth_color};

    @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
      font-size: 14px;
    }
  }

  a {
    line-height: 20px;
    font-weight: bold;
    &:hover,
    &:active,
    &:focus {
      color: ${({ theme }) => theme.colors.fourth_color};
      text-decoration: underline;
    }
  }

  p {
    margin: 0;
  }

  span {
    padding: 0 15px;
  }
`
